































































import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { CurrencyDirective, parseCurrency } from 'vue-currency-input';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {},
  directives: {
    currency: CurrencyDirective
  }
})
export default class ShippingQuoteAnaliseAddItemModal extends BaseComponent {
  @Prop()
  public item;

  @Prop()
  public horarioLimEntregaDesejado;

  @Prop()
  public tpBolsaCompartimentada;

  @Prop()
  public editItem;

  dialogFlag = true;

  dto: any = {};

  public form: any = {
    valid: false,
    rules: {
      horario: [(v) => (v != null && v.length == 5) || 'Informe um horário válido'],
      custo: [(v) => (v != null && v.length > 2) || 'Informe o custo do frete']
    }
  };

  mask2dec = {
    currency: { prefix: 'R$ ', suffix: '' },
    locale: 'pt-BR',
    precision: { min: 2, max: 2 }
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  loading = false;
  error = false;
  items = null;

  mounted() {
    setTimeout(() => {
      if (this.editItem == null) {
        if (this.tpBolsaCompartimentada) {
          this.$refs['tfCusto'].focus();
        } else {
          this.$refs['tfHorarioLimPresc'].focus();
        }
      }
    }, 300);
  }

  @Watch('editItem', { immediate: true })
  onEditItemChange(editItem) {
    if (!editItem) {
      return;
    }
    this.dto = Object.assign(new Object(), editItem);
  }

  closeForm() {
    this.$emit('close');
  }

  salvar() {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.dto.custo = parseCurrency(this.dto.custoFormat, this.mask2dec);
    this.$emit('save', this.dto);
  }
}
